import styled from 'styled-components'
import { media } from 'constants/media/media'

export const Wrapper = styled.div`
	margin: 6rem 0;

	${media.desktopSmall`
		margin: 12rem 0;
	`}
`

export const StyledFilterPlaceholder = styled.div`
	padding-top: 200%;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
`

export const ContentWrapper = styled.div`
	margin-bottom: 3rem;

	${media.desktopSmall`
		margin-bottom: 15rem;
	`}
`

export const TitleWrapper = styled.div`
	${media.mobileOnly`
		margin-top: 2rem;
		margin-left: 2rem;
	`}
`
